import { P2GStack, P2GText, P2GLink, P2GButton, P2GCard, P2GCardContent } from '@parcel2go/core-ui';
import { useTranslation, Trans } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export default function LocalTrackingInfo({ localTrackingLink }: { localTrackingLink?: string }) {
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  return (
    <P2GCard sx={{ height: '100%' }} variant="outlined">
      <P2GCardContent sx={{ height: '100%' }}>
        <P2GStack spacing={2} sx={{ justifyContent: 'space-between', height: '100%' }}>
          <P2GText>
            <Trans
              t={t}
              i18nKey="RESULT_INFORMATION_CARDS_LOCAL_TRACKING_TITLE"
              defaults="We recommend checking the local delivery partner tracking for the latest updates and customs information."
            />
          </P2GText>
          <P2GLink href={localTrackingLink} target="_blank" relationship="noopener noreferrer" underline="none">
            <P2GButton variant="tertiary">
              <Trans t={t} i18nKey="RESULT_INFORMATION_CARDS_LOCAL_TRACKING_BUTTON" defaults="View Local Tracking" />
            </P2GButton>
          </P2GLink>
        </P2GStack>
      </P2GCardContent>
    </P2GCard>
  );
}
